import { notification } from "antd";
import { createReceivingPoint, getBuyerPointsFx, resetPointAddress } from "../store/buyers.store";
import { isString } from 'antd/es/button';

export const handleSave = async ({
    nameString,
    pointName,
    hasMixer,
    buyerId,
    setModalVisible,
    setAddressString
  }: {
    nameString: string,
    pointName: any;
    buyerId: number;
    hasMixer: number;
    setModalVisible: (val: boolean) => void,
    setAddressString: (val: string) => void,
  }) => {
    try {
      const res: any = await createReceivingPoint({
        ...pointName,
        enabled: 1,
        name: nameString,
        buyer_id: buyerId,
        city: pointName.area,
        has_mixer: hasMixer,
      });
      if (res.error) {
        return notification.error({
          message: 'Ошибка',
          description: isString(res.error)
            ? res.error
            : 'Непредвиденная ошибка. Попробуйте позже.',
        });
      }
      if (res.errors) {
        try {
          return notification.error({
            message: 'Неверный адрес',
            description:
              'Адрес должен содержать: регион, город/населенный пункт, улицу, дом',
          });
        } catch (err) {
          return notification.error({
            message: 'Непредвиденная ошибка. Попробуйте позже.',
          });
        }
      }
    } catch (err) {
      return notification.error({
        message: 'Ошибка',
        description: 'Непредвиденная ошибка. Попробуйте позже.',
      });
    }

    notification.success({ message: 'Пункт приема успешно добавлен в систему!' });
    getBuyerPointsFx(buyerId);
    setModalVisible(false);
    setAddressString('');
    resetPointAddress();
  };